<template>
    <div>
        <div
            v-if="content?.config?.title?.value != null && content?.config?.title?.value.trim() !== ''"
            class="font-semibold leading-5"
        >
            {{ content?.config?.title?.value }}
        </div>
        <ProductSlider
            v-if="content.products != null && content.products.length > 0"
            :products="content.products"
            :box-layout="content.config.boxLayout.value"
            :show-add-to-cart="content.config?.showAddToCart?.value === true"
            :slider-id="content.blockId" />
    </div>
</template>

<script setup lang="ts">
import type { HblSlot } from '@/utils/types'

const props = defineProps<{
    content: HblSlot
}>()
</script>
